import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import SuiTypography from "components/SuiTypography";
import CustomSelect from "components/CustomSelect";
import GoalButton from "layouts/goals/components/GoalButton";
import goalSelectStyles from "layouts/goals/components/goalSelectStyles";

function MoveTeamModal({ open, onClose, onMove, isSubmitting, team, organizations }) {
  const [organizationId, setOrganizationId] = useState(null);

  useEffect(() => {
    setOrganizationId(null);
  }, [team, open]);

  const options = organizations
    .filter((organization) => organization.id !== team?.organization_id)
    .map((organization) => ({ value: organization.id, label: organization.name }));

  return (
    <Dialog
      open={open}
      onClose={() => !isSubmitting && onClose()}
      fullWidth
      maxWidth="xs"
      PaperProps={{ sx: { overflow: "visible" } }}
    >
      <DialogTitle>Move workspace</DialogTitle>
      <DialogContent sx={{ overflow: "visible" }}>
        <SuiTypography variant="button" color="text" display="block" mb={2}>
          {team?.name} and everything in it (people, attendance, requests) moves to the organization
          you pick. Admins of the old organization lose access to it, and it can&apos;t be moved
          while its people still hold company assets.
        </SuiTypography>
        <CustomSelect
          options={options}
          value={options.find((option) => option.value === organizationId) || null}
          onChange={(option) => setOrganizationId(option.value)}
          customStyles={goalSelectStyles}
          menuPortalTarget={document.body}
          placeholder="Select organization"
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton
          variant="primary"
          icon="drive_file_move"
          loading={isSubmitting}
          disabled={!organizationId}
          onClick={() => onMove(team.id, organizationId)}
        >
          Move
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default MoveTeamModal;
